import { Menu } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { LookupEditField } from './LookupEditField';
import { EntityAndField } from './types';
import styles from './RelatedLookupFieldOverflowMenu.module.css';

interface LookupOverflowMenuContentProps {
  lookupFields: EntityAndField[];
  lookupComponent: API.AnyComponent;
  workflowTemplateId: string;
  title?: string;
}

/**
 * The body rendered inside a lookup overflow `Menu.Content`: a title followed by a scrollable
 * list of every looked-up value, each showing its source path. Shared by the eager (card form)
 * and lazy (collection view) overflow menus.
 */
export function LookupOverflowMenuContent({
  lookupFields,
  lookupComponent,
  workflowTemplateId,
  title,
}: LookupOverflowMenuContentProps) {
  return (
    <>
      <Menu.Section className={styles.menuTitle}>
        <Text size="body1" weight="semibold">
          {title}
        </Text>
      </Menu.Section>
      <Menu.Scrollable showScrollIndicators>
        <View paddingHorizontal={1.5} paddingVertical={1} gap={1}>
          {lookupFields.map(field => (
            <LookupEditField
              key={field.entity.id}
              field={field.field}
              entity={field.entity}
              sources={field.sources}
              lookupComponent={lookupComponent}
              workflowTemplateId={workflowTemplateId}
              showLabel={false}
              style={{ boxShadow: '0 0 50px 0px rgba(0, 0, 0, 0.02)' }}
            />
          ))}
        </View>
      </Menu.Scrollable>
    </>
  );
}
